export default "__VITE_ASSET__f2e11547__"